module.exports = __webpack_public_path__ + "img/nodata_big.ee98230c.png";